import PropTypes from 'prop-types';
import {ButtonLink} from 'ui';
import {Overlay, Sheet, CloseButton, DetailTitle, DetailImage, DetailText} from './styles';

// Espace insécable devant ? ! : ; pour que la ponctuation ne passe jamais seule à la ligne.
const keepPunctuation = text => text.replace(/ ([!:;?])/g, '\u00A0$1');

// Marche à suivre d'une action, telle que saisie dans le back-office pour la page /recompense/.
const ActionDetail = ({action, onClose}) => {
  const {actions_modal_title: title, actions_modal_text: text, actions_modal_link: link} = action.acf;
  const hasLink = link && typeof link === 'object' && link.url;

  return (
    <Overlay onClick={onClose}>
      <Sheet role="dialog" aria-modal="true" onClick={event => event.stopPropagation()}>
        <CloseButton type="button" aria-label="Fermer" onClick={onClose} />
        {title && <DetailTitle>{keepPunctuation(title)}</DetailTitle>}
        {action.acf.actions_image && <DetailImage src={action.acf.actions_image} alt="" />}
        {text && (
          <DetailText
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: text}}
          />
        )}
        {hasLink && (
          <ButtonLink href={link.url} target="_blank" rel="noopener noreferrer" color="white">
            {link.title || link.url}
          </ButtonLink>
        )}
      </Sheet>
    </Overlay>
  );
};

ActionDetail.propTypes = {
  action: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActionDetail;
